/**
 * @author Jensen<zhhnch@gmail.com>
 * @description 依赖vue-route和vue-i18n
 * @since 2018/4/10
 * @example
- 组件混合方式
```
 // App.vue
 <template>
   <div id="app" v-dynamic-title="generateTitle()">
     <router-view/>
   </div>
 </template>

 <script>
   import dynamicTitle from 'vue-dynamic-title';

   export default {
      name: 'App',
      mixins: [ dynamicTitle ]
   }
 </script>
```

- 全局混合方式
 ```
   // main.js
   import dynamicTitle from 'vue-dynamic-title';
   Vue.mixin(dynamicTitle);

   // App.vue
   <template>
     <div id="app" v-dynamic-title="generateTitle()">
       <router-view/>
     </div>
   </template>
 ```

- 仅使用指令方式
 ```
 //main.js
 import {directive as dynamicTitle} from 'vue-dynamic-title';
 Vue.directive(dynamicTitle);

 // App.vue
 <template>
   <div id="app" v-dynamic-title="customTitle">
     <router-view/>
   </div>
 </template>
 ```
*/

const directive = (el, binding) => {
  const title = document.querySelector('title')
  if (title) {
    title.innerText = binding.value
  }
}

const mixin = {

  methods: {
    generateTitle (separator = '-') {
      let arr = this._matchRouteTitle()
      arr = arr.map(title => {
        return this._translateTitle(title, 'route.')
      })
      arr.unshift(this._translateTitle('title'))
      return arr.reverse().join(separator)
    },

    _matchRouteTitle () {
      const $route = this.$route
      let arr = []
      for (let match of $route.matched) {
        if (match && match.meta && match.meta.title) {
          arr.push(match.meta.title)
        }
      }
      return arr
    },

    _translateTitle (title, prefix = '') {
      const titleKey = `${prefix}${title}`
      const hasKey = this.$te(titleKey)
      const translatedTitle = this.$t(titleKey)
      if (hasKey) {
        return translatedTitle
      }
      return title
    }
  },

  directives: {
    dynamicTitle: directive
  }

}

export {
  directive,
  mixin as default
}
